'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import WildsLaunchContainer from '../WildsLaunchContainer';
import ParallaxText from '@components/ParallaxText';
import { ImageObj } from '@custom-types/ImageObj.types';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
interface VillasLaunchWelcomeProps {
  t: any;
  welcomeBgImage: ImageObj;
}
export default function VillasLaunchWelcome(props: VillasLaunchWelcomeProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsWelcome}>
      <Box className={cn.wildsWelcomeBackground}>
        <Image
          src={props.welcomeBgImage.url}
          alt="Villas Launch Welcome - Welcome Bg Image"
          width={768}
          height={768}
        />
      </Box>
      <Stack className={cn.wildsWelcomeInner}>
        <WildsLaunchContainer>
          <Box className={cn.wildsWelcomeBlock}>
            <Box className={cn.wildsWelcomeBlock__header}>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(t['welcomeHeading'])}
              </ParallaxText>
            </Box>
            <Box className={cn.wildsWelcomeBlock__content}>
              <ParallaxText
                variant="p"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(t['welcomeDesc'])}
              </ParallaxText>
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
    </Box>
  );
}
